export interface DraftAgreement {
    userId: number
    accountantId: number
    agreementText: string
    type: UserAgreementTypeTypes
}

export interface Agreement extends DraftAgreement {
    signedDateUTC: string
}

export const UserAgreementType = {
    Personal: 'Personal',
    Company: 'Company',
} as const

export type UserAgreementTypeTypes = (typeof UserAgreementType)[keyof typeof UserAgreementType]
